import CnpjUtils from "../../shared/utils/CnpjUtils";

const URL_BASE = `${process.env.REACT_APP_ESSILOR_API}gestao-financeira-cliente-laboratorio/v1/`;
const DOCUMENTO_NAO_ENCONTRADO = "Registro não encontrado no laboratório";

function montarHeaders({ laboratorio, otica }) {
  const headers = {
    access_token: sessionStorage.getItem("token"),
    client_id: localStorage.getItem("clientid"),
    laboratorio,
  };
  const cnpjOtica = CnpjUtils.cleanCnpj(otica);
  if (cnpjOtica) headers.otica = cnpjOtica;
  return headers;
}

async function requisitar(caminho, opcoes) {
  try {
    const response = await fetch(URL_BASE + caminho, opcoes);
    const json = await response.json().catch(() => null);

    if (response.status >= 400) {
      const mensagem = Array.isArray(json) ? json[0]?.mensagem : json?.mensagem;
      return { status: response.status, json: null, erro: mensagem || "" };
    }

    return { status: response.status, json, erro: "" };
  } catch (error) {
    return { status: 0, json: null, erro: "" };
  }
}

async function getNotasFiscais({ laboratorio, otica, dataInicio, dataFim, pagina, tamanho }) {
  const query = `dataInicio=${dataInicio}&dataFim=${dataFim}&size=${tamanho}&page=${pagina}`;
  const { status, json, erro } = await requisitar(`notas-fiscais?${query}`, {
    method: "GET",
    headers: montarHeaders({ laboratorio, otica }),
  });

  const notas = json?.notasFiscais ?? json?.resultado;

  return {
    status,
    notas: Array.isArray(notas) ? notas : [],
    total: Number(json?.total) || 0,
    erro,
  };
}

async function postDownloadNotasFiscais({ laboratorio, otica, notas }) {
  const { status, json, erro } = await requisitar("notas-fiscais/download", {
    method: "POST",
    headers: { ...montarHeaders({ laboratorio, otica }), "Content-Type": "application/json" },
    body: JSON.stringify({
      notasFiscais: notas.map(nota => ({ numero: nota.numero, codigoEmpresa: nota.codigoEmpresa })),
    }),
  });

  if (status === 200 && !json?.conteudo) {
    return { status: 404, conteudo: "", erro: "" };
  }

  return { status, conteudo: json?.conteudo || "", erro };
}

async function getDanfe({ laboratorio, otica, numero, tipoDocumento }) {
  const query = `numeroNotaFiscal=${encodeURIComponent(numero)}&tipoDocumento=${tipoDocumento}`;
  const { status, json, erro } = await requisitar(`danfe/?${query}`, {
    method: "GET",
    headers: montarHeaders({ laboratorio, otica }),
  });
  const documento = json?.documento;

  if (status === 200 && (!documento || documento === DOCUMENTO_NAO_ENCONTRADO)) {
    return { status: 404, documento: "", erro: "" };
  }

  return { status, documento: documento || "", erro };
}

export { getNotasFiscais, postDownloadNotasFiscais, getDanfe };
